import {Component, Input} from '@angular/core';

@Component({
  selector: 'ngx-auth-firebaseui-email-confirmation',
  template: `
    <mat-card-content fxLayout="column" fxLayoutAlign="center center">
      <mat-icon>email</mat-icon>
      <div class="title">
        Confirm your e-mail address!
      </div>
      <div class="subtitle">
        <p>A confirmation e-mail has been sent to
          <b><strong>{{email}}</strong></b>.</p>
        <p>Check your inbox and click on the link
                       "Confirm my e-mail" to confirm your e-mail address.</p>
      </div>
    </mat-card-content>

    <mat-card-actions *ngIf="goBackURL"
                      fxLayoutAlign="center center">
      <a mat-button
         color="primary"
         [href]="goBackURL">
        Go back
      </a>
    </mat-card-actions>
  `,
  styles: [`
    .material-icons{font-size:4rem}.mat-icon{height:4rem;width:4rem;color:rgba(0,0,0,.54)}.title{font-size:20px;margin-top:16px}.subtitle{margin:16px auto;max-width:300px;color:rgba(0,0,0,.54);font-size:15px;text-align:center}.subtitle p{display:block;-webkit-margin-before:1em;-webkit-margin-after:1em;-webkit-margin-start:0;-webkit-margin-end:0}
  `]
})
export class EmailConfirmationComponent {

  @Input()
  email: string;

  @Input()
  goBackURL: string;

}
